export const guardParentColumns = [
  { id: 'expand', label: '', width: '5%' },
  { id: 'date', label: 'Date', width: '25%' },
  { id: 'totalHours', label: 'Total Hours', width: '70%' },
];

export const guardChildColumns = [
  { id: 'spacer', label: '', width: '5%' },
  { id: 'startTime', label: 'Start Time', width: '20%' },
  { id: 'endTime', label: 'End Time', width: '20%' },
  { id: 'address', label: 'Address', width: '30%' },
  { id: 'customerName', label: 'Customer', width: '25%' },
];
